import * as React from "react";
import * as ReactDOM from "react-dom";

import App from "./App"

ReactDOM.render(<App/>, document.querySelector("#root"));




// WEBPACK FOOTER //
// ./docs-src/index.tsx